import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static values = {
    dateFormat: { type: String, default: "d/m/Y" },
    minDate: String,
    maxDate: String,
    disable: { type: Array, default: [] }
  }

  connect() {
    this.picker = flatpickr(this.element, {
      dateFormat: this.dateFormatValue,
      minDate: this.minDateValue ? new Date(this.minDateValue + 'T00:00:00') : undefined,
      maxDate: this.maxDateValue ? new Date(this.maxDateValue + 'T00:00:00') : undefined,
      // Disable entries must be ISO YYYY-MM-DD; raw strings would be parsed via dateFormat (d/m/Y) and misread.
      disable: this.disableValue.map(d => new Date(d + 'T00:00:00'))
    })
  }

  disconnect() {
    this.picker?.destroy()
  }
}
